import { render, staticRenderFns } from "./merged-progress-prioritization-config-modal.vue?vue&type=template&id=4ce310e6&"
import script from "./merged-progress-prioritization-config-modal.vue?vue&type=script&lang=js&"
export * from "./merged-progress-prioritization-config-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports